import getLoyaltyAccountRegion from 'loyalty/selectors/getLoyaltyAccountRegion'
import getIsLoyaltyEsimEnabled from 'loyalty/selectors/getIsLoyaltyEsimEnabled'
import { isEsimExcludedCountry } from 'loyalty/lib/esimGeoExclusion'

// Union of all offer types that can be checked for loyalty benefit eligibility.
export type LoyaltyEligibleOffer = App.AnyOffer | App.VillaOffer | App.VillaOfferSummary | App.BundledOffer

interface OfferWithProperty {
  property?: {
    geoData?: { countryCode?: string }
    address?: { countryCode?: string }
  }
}

function getOfferDestinationCountryCode(offer: LoyaltyEligibleOffer): string | undefined {
  if (!('property' in offer)) return undefined
  const { property } = offer as OfferWithProperty
  return property?.geoData?.countryCode ?? property?.address?.countryCode
}

function getIsInternationalDestination(state: App.State, destinationCountry: string): boolean {
  const accountRegion = getLoyaltyAccountRegion(state)
  if (!accountRegion) return false
  return destinationCountry.toLowerCase() !== accountRegion.toLowerCase()
    && !isEsimExcludedCountry(destinationCountry)
}

function isLoyaltyMember(state: App.State): boolean {
  return !!state.loyalty.account.data
}

export function getIsOfferEsimEligible(state: App.State, offer: LoyaltyEligibleOffer): boolean {
  if (!getIsLoyaltyEsimEnabled(state)) return false
  if (!isLoyaltyMember(state)) return false
  const destinationCountry = getOfferDestinationCountryCode(offer)
  if (!destinationCountry) return false
  return getIsInternationalDestination(state, destinationCountry)
}

export function getIsTourVariationEsimEligible(state: App.State, variation: App.Tours.TourV2OfferVariation): boolean {
  if (!getIsLoyaltyEsimEnabled(state)) return false
  if (!isLoyaltyMember(state)) return false
  const countries = variation?.countriesVisited ?? []
  if (!countries.length) return false
  const accountRegion = getLoyaltyAccountRegion(state)
  if (!accountRegion) return false
  const region = accountRegion.toLowerCase()
  const hasInternational = countries.some((c) => !!c && c.toLowerCase() !== region)
  if (!hasInternational) return false
  const hasExcluded = countries.some((c) => c && isEsimExcludedCountry(c))
  return !hasExcluded
}
